import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import Section from '../Section'
import { H1 } from '../Typography'
import { GridContainer, ContentContainer } from '../Grid'
import Image from '../Image'

import { Colors, Gutter, Heights } from '../../utils/styles'

import assets from '../../content/assets'
import toolContent from '../../content/toolContent'

const StyledSection = styled(Section)`
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) : {
    margin-top: ${Heights.PRIMARY_NAV_BAR};
  }
`

const ProductIcon = styled(Image)({})

const StyledGridContainer = styled(GridContainer)({
  alignItems: 'center',
  flexWrap: 'wrap',
})

const Title = styled(H1)({
  color: Colors.WHITE,
  fontWeight: 700,
  marginTop: 20,
  marginBottom: Gutter.FULL,
})

const Description = styled.p({
  color: Colors.WHITE,
  fontSize: 20,
  fontWeight: 400,
  lineHeight: 1.6,
  maxWidth: 600,
})

const ImageContainer = styled.div({
  // padding: Gutter.FULL,
})

const ProductHero = props => (
  <StyledSection backgroundColor={props.backgroundColor} backgroundImage={props.backgroundImage}>
    <StyledGridContainer>
      <ContentContainer width={[1, 1, 1 / 3]} p={[Gutter.HALF, Gutter.FULL, Gutter.FULL]}>
        <div style={{ padding: Gutter.HALF }}>
          <ProductIcon src={props.icon} alt={props.iconAltText} width="60px" />
          <Title>{props.title}</Title>
          <Description>{props.description}</Description>
        </div>
      </ContentContainer>
      <ContentContainer width={[1, 1, 2 / 3]}>
        <ImageContainer>
          <Image src={props.image} alt={props.imageAltText} />
        </ImageContainer>
      </ContentContainer>
    </StyledGridContainer>
  </StyledSection>
)

export default ProductHero

ProductHero.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  backgroundColor: PropTypes.string,
  backgroundImage: PropTypes.string,
  image: PropTypes.string,
  imageAltText: PropTypes.string,
  icon: PropTypes.string,
  iconAltText: PropTypes.string,
}

ProductHero.defaultProps = {
  title: 'Tool Name',
  description: 'tool description',
  backgroundColor: Colors.SECONDARY,
  backgroundImage: assets.images.noise2,
  image: assets.images.homeProductScreenHero,
  imageAltText: 'Pulse Analytics Tool Image',
  icon: toolContent.icon.payer,
  iconAltText: 'Tool Icon',
}
